<template>
  <div class="card" v-bind="$attrs" :class="darkMode ? 'bg-gradient-dark' : ''">
    <div class="pb-0 card-header" :class="darkMode ? 'bg-transparent' : ''">
      <h6 :class="darkMode ? 'text-white' : ''">{{ title }}</h6>
      <!--  eslint-disable-next-line vue/no-v-html -->
      <p class="text-sm" v-html="description"></p>
    </div>
    <div class="p-3 card-body">
      <div class="timeline timeline-one-side" :data-timeline-axis-style="darkMode ? 'dashed' : 'dotted'">
        <slot />
      </div>
      <div v-if="summarylist" class="mt-2">
        <p class="text-xs text-secondary font-weight-normal p-0 m-0" v-for="(item, index) in summarylist" :key="index">
          {{ item }}
        </p>
      </div>

      <div v-if="type == 'admin'" class="text-center w-100 mt-2">
        <a :href="`${baseUrl}/MF/cs-mf-manageschedules/`">
          <material-button color="info" variant="outline">
            Manage Schedules/Assignments
          </material-button>
        </a>
      </div>

      <div v-else class="text-center w-100 mt-2">
        <material-button color="info" variant="outline" @click="openMySchedulesModal">
          View/Respond to Assignments
        </material-button>
      </div>

    </div>
  </div>

  <!-- Modal for My Schedules -->
  <Modal v-if="isModalOpen" :modalHeading="modalHeading" :modalContent="modalContent" :iframeUrl="iframeUrl"
    size="xl" refresh-on-close @close="closeModal" />
</template>

<script>
import { mapGetters } from 'vuex';
import MaterialButton from '../common/MaterialButton.vue';
import Modal from '@/components/Modal/Modal.vue';
import { baseUrl } from '@/utils/BaseUrl.js';

export default {
  name: "TimelineList",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    summarylist: {
      type: [Array, null],
      default: () => null
    },
    type: {
      type: String,
      default: ""
    }
  },
  components: {
    MaterialButton,
    Modal
  },
  data() {
    return {
      isModalOpen: false,
      modalHeading: "My Schedules",
      modalContent: "",
      iframeUrl: "",
      baseUrl: baseUrl
    };
  },
  computed: {
    ...mapGetters([
      "stSessionData",
    ]),
  },
  methods: {
    openMySchedulesModal() {
  this.iframeUrl = `${this.baseUrl}/MF/cs-mf-personschedule/?personid=${this.stSessionData.personId}`
      this.modalHeading = "My Schedules";
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    }
  }
};
</script>
